
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/student-agreement-form",
      function () {
        return require("private-next-pages/training/student-agreement-form.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/student-agreement-form"])
      });
    }
  